import type { FaireProductEntity } from "../../entity_types/product";

export const p_qq8scfss8d: FaireProductEntity = {
  token: "p_qq8scfss8d",
  type: "product",
  name: "Unscented Whipped Tallow",
  brandToken: "b_rvn46uxywb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/97a077a4083073e9e0632607da22a5e80b0d23b22dd53f04bf4becef677487a7.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.32,
  description:
    "Tallow has been used as a natural moisturizer for ages. High in antioxidants & vitamins like A, D, E, and K it closely mimics our own skin's makeup to nourish, rejuvenate, and repair without clogging pores. Our tallow balm is crafted with care using only pure ingredients: homegrown organic calendula right from our herb farm and grass-fed beef tallow. Our tallow is slow infused, never diluted with other oils.  Easily saturates skin, a little of this goes a long way. Great for all skin types, ages, and applications, even your face!",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:21.316Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
